import { useQuery } from "@apollo/client/react";
import { queries } from "@/graphql";

const GET_DATAHUB_CUSTOMERS = queries.dataHubCustomers;
const GET_DATAHUB_CUSTOMER_BUILDINGS = queries.dataHubCustomerBuildings;
const GET_DATAHUB_BUILDING_METERS = queries.datahubBuildingMeters;
const GET_DATAHUB_METER_DETAILS = queries.datahubMeteringdataDaily;
const GET_DATAHUB_METER_DETAILS_MONTHLY = queries.datahubMeteringdataTsMonthly;
const GET_DATAHUB_METER_DETAILS_YEARLY = queries.datahubMeteringdataTsYearly;

/**
 *
 */
export function useDataHubCustomers() {
  const { data, loading } = useQuery<any>(GET_DATAHUB_CUSTOMERS, {});

  return {
    customersList: data?.dataHubCustomers || [],
    loading,
  };
}

/**
 *
 * @param id
 */
export function useDataHubCustomerBuildings(id: string | null | undefined) {
  const { data, loading } = useQuery<any>(GET_DATAHUB_CUSTOMER_BUILDINGS, {
    variables: {
      id,
    },
  });

  return {
    buildingsList: data?.dataHubCustomerBuildings || [],
    loading,
  };
}

/**
 *
 * @param meterIdList
 */
export function useDataHubBuildingMeters(meterIdList: string[] | undefined) {
  const { data, loading } = useQuery<any>(GET_DATAHUB_BUILDING_METERS, {
    variables: {
      meterIdList,
    },
  });

  return {
    metersList: data?.datahubBuildingMeters || [],
    loading,
  };
}

/**
 *
 * @param meteringPointId
 * @param daily
 */
export function useDataHubMeterDetailsDaily(
  meteringPointId: string | undefined,
  daily: Date | null | undefined,
) {
  const { data, loading } = useQuery<any>(GET_DATAHUB_METER_DETAILS, {
    variables: {
      meteringPointId,
      daily,
    },
  });

  return {
    meterDetailDaily: data?.datahubMeteringdataDaily || [],
    loading,
  };
}

/**
 *
 * @param meteringPointId
 * @param month
 */
export function useDataHubMeterDetailsMonthly(
  meteringPointId: string | undefined,
  month: Date | null | undefined,
) {
  const { data, loading } = useQuery<any>(GET_DATAHUB_METER_DETAILS_MONTHLY, {
    variables: {
      meteringPointId,
      month,
    },
  });

  return {
    meterDetailMonthly: data?.datahubMeteringdataTs[0]?.dailyData || [],
    period: data?.datahubMeteringdataTs[0]?.period || {},
    loading,
  };
}

/**
 *
 * @param meteringPointId
 * @param year
 */
export function useDataHubMeterDetailsYearly(
  meteringPointId: string | undefined,
  year: Date | null | undefined,
) {
  const { data, loading } = useQuery<any>(GET_DATAHUB_METER_DETAILS_YEARLY, {
    variables: {
      meteringPointId,
      year,
    },
  });

  return {
    meterDetailYearly: data?.datahubMeteringdataTs || [],
    loading,
  };
}
